import { Button, Checkbox } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import { SettingFilled } from '@ant-design/icons';
import { ClosablePopover } from '../../../common/ClosablePopover';
import { FilterLogic, FLIGHT_TV_FILTER_CONFIG_CLAZZ_VALUE, FlightTvFilterConfig } from '../../../../model/SOL49';
import { LoadClassification } from '../../../../model/CORE';
import { FilterSettings } from '../../../../model/client/SOL49';

export const DEFAULT_FLIGHTS_TV_SETTINGS: FlightsTvFilterSettings = {
    filterLogic: FilterLogic.UNION,
    config: {
        clazz: FLIGHT_TV_FILTER_CONFIG_CLAZZ_VALUE,
        onlyAboveThreshold: false,
        marginMs: 0,
        threshold: LoadClassification.OVERLOAD,
    },
};

export interface FlightsTvFilterSettings extends FilterSettings<FlightTvFilterConfig> {}

export class FlightsTvFilterSettingsContent extends SettingsContentPanel<FlightsTvFilterSettings> {
    handleOnlyContributesToOverloadChange = changeEvent => {
        const config = { ...this.state.config, onlyAboveThreshold: changeEvent.target.checked };
        this.setState({ config: config });
    };
    handleThresholdChange = value => {
        const config = { ...this.state.config, threshold: value };
        this.setState({ config: config });
    };
    handleMarginChange = value => {
        const config = { ...this.state.config, marginMs: value };
        this.setState({ config: config });
    };
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '30em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.filterLogic === FilterLogic.INTERSECT}
                        onChange={value =>
                            this.setState({
                                filterLogic: value.target.checked ? FilterLogic.INTERSECT : FilterLogic.UNION,
                            })
                        }>
                        Show only common TVs overflown by the selected flights
                    </Checkbox>
                </Flex>
                {/*<Flex className='label'>
                    <Checkbox
                        checked={this.state.config?.onlyAboveThreshold === true}
                        onChange={this.handleOnlyContributesToOverloadChange}
                    >
                        Show only TVs above a given theshold when overflown
                    </Checkbox>
                </Flex>
                <Flex style={{alignSelf: 'center', paddingBottom: '0.5em'}}>
                    <div className='label' style={{marginRight: '1em'}}>
                        Threshold
                    </div>
                    <div>
                        <Select
                            value={this.state.config?.threshold}
                            disabled={!this.state.config?.onlyAboveThreshold}
                            onChange={this.handleThresholdChange} style={{width: '10em'}}
                        >
                            <Select.Option value={LoadClassification.LOW_THRESHOLD}>Low threshold</Select.Option>
                            <Select.Option value={LoadClassification.HIGH_THRESHOLD}>High threshold</Select.Option>
                            <Select.Option value={LoadClassification.OVERLOAD}>Overload</Select.Option>
                        </Select>
                    </div>
                </Flex>
                <Flex style={{alignSelf: 'center'}}>
                    <div className='label' style={{marginRight: '1em'}}>
                        Margin
                    </div>
                    <div>
                        <Select
                            value={this.state.config?.marginMs}
                            disabled={!this.state.config?.onlyAboveThreshold}
                            onChange={this.handleMarginChange} style={{width: '8em'}}
                        >
                            <Select.Option value={0}>No margin</Select.Option>
                            <Select.Option value={300000}>+/- 5mn</Select.Option>
                            <Select.Option value={600000}>+/- 10mn</Select.Option>
                            <Select.Option value={1200000}>+/- 20mn</Select.Option>
                            <Select.Option value={1800000}>+/- 30mn</Select.Option>
                        </Select>
                    </div>
                </Flex>*/}
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}

interface TvFlightsFilterSettingsButtonProps {
    settings: FlightsTvFilterSettings;
    onSettingsChange: (settings: FlightsTvFilterSettings) => void;
}

export class FlightsTvFilterSettingsButton extends PureComponent<TvFlightsFilterSettingsButtonProps> {
    private settingsPopoverRef = React.createRef<ClosablePopover>();
    handleSettingsChange = (settings: FlightsTvFilterSettings) => {
        this.props.onSettingsChange?.(settings);
        this.settingsPopoverRef.current.hide();
    };
    getTvFlightsFilterSettingsContent = () => {
        return (
            <FlightsTvFilterSettingsContent
                settings={this.props.settings}
                onChange={this.handleSettingsChange}
                onClose={() => {
                    this.settingsPopoverRef.current.hide();
                }}
            />
        );
    };
    render() {
        return (
            <ClosablePopover
                key="settings-action"
                ref={this.settingsPopoverRef}
                trigger="click"
                placement="bottom"
                title={<div style={{ fontWeight: 'bold' }}>FILTER'S SETTINGS</div>}
                content={this.getTvFlightsFilterSettingsContent()}>
                <Button
                    onClick={() => this.settingsPopoverRef.current.show()}
                    style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                    <SettingFilled />
                </Button>
            </ClosablePopover>
        );
    }
}
